import emitter from 'eventemitter3';

export const globalEventEmitter = new emitter();

export class Events {
    static notify = ({message}: {message: string}) => {
        globalEventEmitter.emit('SHOW_SNACKBAR', {message});
    };
}
